import { UPDATE_SIGNALR_STATE } from "../actions/index";
import { Store as notifyStore } from "react-notifications-component";
import {
  tempOptions,
  //permanentOptions,
  NotifyContent,
} from "../../components/Notify";

import { t } from "i18next";

// True once the user has been told the stream is down. Drives both directions:
// we report a problem once, and only announce recovery from a problem we
// actually reported. Comparing against state.connection is not enough — the
// initial state is already `false`, so a stream that never came up (MSAL
// redirect in flight) would report "no change" and stay silent while the user
// sits in front of a dead page.
let hasReportedProblem = false;

const signalR = (state = { connection: false }, action) => {
  switch (action.type) {
    case UPDATE_SIGNALR_STATE: {
      const isConnected = action.payload.connection === true;
      const shouldNotify = isConnected ? hasReportedProblem : !hasReportedProblem;

      if (shouldNotify) {
        notifyStore.addNotification({
          ...tempOptions,
          content: NotifyContent(
            isConnected ? "success" : "danger",
            "Data Streaming",
            isConnected
              ? t("common:signalR.connectionOn")
              : t("common:signalR.connectionOff")
          ),
        });
      }
      hasReportedProblem = !isConnected;
      return { ...state, connection: action.payload.connection };
    }
    default:
      return state;
  }
};

export default signalR;
